export const GRANTABLE_NOTIFICATION_SCOPES = [
  "medical_information:read",
  "medical_information:create",
  "medical_information:update",
  "medical_information:delete",
  "medical_document:read",
  "medical_document:create",
  "medical_document:update",
  "medical_document:delete",
  "medical_document:archive",
  "medication:read",
  "medication:create",
  "medication:update",
  "medication:delete",
  "medication:stop",
];

const grantableScopes = new Set(GRANTABLE_NOTIFICATION_SCOPES);

export const getNotificationRequestedScopes = (notification) => {
  const candidates = [
    notification?.requestedScopes,
    notification?.metadata?.requestedScopes,
    notification?.data?.requestedScopes,
    notification?._raw?.requestedScopes,
    notification?._raw?.metadata?.requestedScopes,
  ];
  const scopes = candidates.find(Array.isArray);
  if (!scopes?.length) return null;

  const normalized = Array.from(
    new Set(
      scopes
        .map((scope) => String(scope ?? "").trim())
        .filter((scope) => grantableScopes.has(scope)),
    ),
  );

  return normalized.length ? normalized : null;
};
